import { Game } from '@denishussar/html5-game-engine';
import { GameInstance } from './game/GameInstance';

import * as WebFont from 'webfontloader';
import { Sounds } from './game/Constants/Sounds';
import { LocalizationContents } from './game/LocalizationContents';

declare var require;
require('../fonts/fonts.css');
const gameCfg = require('../game-config.json');
const version = require('./../package.json').version;

declare global {
    interface Window {
        API_callback: (method, result, data) => void;
        ethereum: any;
        webkit: any;
    }
}

window.API_callback = function(method, result, data) {
    console.log(method, result, data);
}

export class Games {
    public static startGame(elementId?: string): Game {
        return new Game({
            main: GameInstance,
            version: version,
            sounds: [
                {
                    id: Sounds.DRIVE_1,
                    path: "/sounds/Car_Ride_1.mp3"
                },
                {
                    id: Sounds.DRIVE_2,
                    path: "/sounds/Car_Ride_1.mp3"
                },
                {
                    id: Sounds.DRIVE_3,
                    path: "/sounds/Car_Ride_1.mp3"
                },
                {
                    id: Sounds.DRIVE_4,
                    path: "/sounds/Car_Ride_1.mp3"
                },
                {
                    id: Sounds.ACCELERATION_1,
                    path: "/sounds/Car_Acceleration_1.mp3"
                },
                {
                    id: Sounds.SWAP_LINE,
                    path: "/sounds/Car_Swap_Line.mp3"
                },
                {
                    id: Sounds.COL_CAR,
                    path: "/sounds/Collision_Car.mp3"
                },
                {
                    id: Sounds.COL_DEGEN,
                    path: "/sounds/Collision_Degen.mp3"
                },
                {
                    id: Sounds.COL_DPS,
                    path: "/sounds/Collision_DPS.mp3"
                },
                {
                    id: Sounds.COL_UNICORN,
                    path: "/sounds/Collision_Unicorn.mp3"
                },
                {
                    id: Sounds.TAKE_ITEM,
                    path: "/sounds/Take_Item.mp3"
                },
                {
                    id: Sounds.USE_DEGEN,
                    path: "/sounds/Use_Item_Degen.mp3"
                },
                {
                    id: Sounds.USE_BANDITS,
                    path: "/sounds/Use_Item_Bandits.mp3"
                },
                {
                    id: Sounds.USE_DPS,
                    path: "/sounds/Use_Item_DPS.mp3"
                },
                {
                    id: Sounds.USE_UNICORN,
                    path: "/sounds/Use_Item_Unicorn.mp3"
                },
                {
                    id: Sounds.BUTTON,
                    path: "/sounds/Button.mp3"
                },
                {
                    id: Sounds.CHECKPOINT_1,
                    path: "/sounds/Check_Point.mp3"
                },
                {
                    id: Sounds.CHECKPOINT_2,
                    path: "/sounds/Check_Point_2.mp3"
                },
                {
                    id: Sounds.PURCHASE,
                    path: "/sounds/Purchase.mp3"
                },
                {
                    id: Sounds.TUNING,
                    path: "/sounds/Tuning.mp3"
                },
                {
                    id: Sounds.END_GAME,
                    path: "/sounds/End_Game.mp3"
                },
                {
                    id: Sounds.MUSIC_MENU,
                    path: "/sounds/Music_Menu.mp3"
                },
                {
                    id: Sounds.MUSIC_TRACK_1,
                    path: "/sounds/Music_Track_1.mp3"
                },
                {
                    id: Sounds.MUSIC_TRACK_2,
                    path: "/sounds/Music_Track_2.mp3"
                },
            ],
            assetsRoot: gameCfg.resourcesRoot,
            elementId: elementId || 'gamePlace',
            noWebGL: false,
            backgroundColor: 0x040131,
            clearBeforeRender: true,
            transparent: false,
            showStats: false,
            fps: 60,
            gameId: gameCfg.gameId,
            orientations: [],
        });
    }
}

WebFont.load({
    custom: {
        families: [
            'Progress(RUS BY LYAJKA)',
            'Lucida Console',
            'Cimero Pro',
            'CimeroProRegular',
            'Digital-7 Mono',
            'Roboto Condensed',
            'Bahnschrift',
        ],
    },
    loading: () => Games.startGame(),
});

LocalizationContents.setLanguage();
